<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper cart-wrapper cart-page">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <div class="nav-bar-wrapper">
            <div class="nab-bar-left">
              <button @click="goBack()" class="button is-flex nav-back">
                <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back" />
              </button>
              <h1 class="has-text-black">My Cart</h1>
            </div>
            <div class="nav-bar-right">
              <button
                v-if="vg_cartItems.length > 0"
                @click="clearCartModal()"
                class="button is-medium bg-secondary text-white hover-opacity-7 clear-cart"
              >Clear Cart</button>
            </div>
          </div>
        </div>
      </app-header>
    
      <!-- If no cart item -->
      <main class="content-wrapper" v-if="vg_cartItems.length < 1">
        <section class="section has-text-grey has-text-centered mt100 mb100 mt0-mobile mb0-mobile">
          <img src="@/assets/img/icon-basket.svg" alt="image" />
          <p class="is-size-16 mt50">Your cart is empty</p>
          <router-link
            class="button button mt5 pa15 bg-secondary text-white hover-opacity-7"
            :to="{ name: 'StoreProfile', params: { business_slug: $route.params.business_slug, store_slug: $route.params.store_slug }, query: $route.query }"
          >Browse products</router-link>
        </section>
      </main>

      <!-- If has cart item -->
      <main class="content-wrapper" v-else>

        <cart-skeleton v-if="loaded == false"/>

        <section class="section" v-else>
          <div class="container">
            <div class="columns justify-content-between is-space-25">
              <div class="column is-6-tablet">
           
                <!-- cart item -->
                <template v-if="cartLoaded">
                  <cart-item
                    v-for="(product, index) in vg_cartItems"
                    :item="product"
                    v-bind:key="'cart-item-' + index"
                  ></cart-item>
                </template>

                 <div class="">
                    <div class="is-flex justify-content-between mb-3">
                    <p class="is-size-16">Limit</p>
                    <p class="is-size-16">
                      {{ vg_weightOnCart }}g /
                      <span class="">{{ vg_cannabisLimit }}g</span>
                    </p>
                  </div>

                   <router-link
                      v-if="vg_selectedStore.slug"
                      class="button is-primary-outline cart-add-more is-medium is-full-width"
                      :to="{ name: 'StoreProfile', params: { store_id: vg_selectedStore.slug }, query: $route.query }"
                    >
                      ADD MORE ITEMS
                    </router-link>
                 </div>

              </div>
              
              <div class="column is-6-tablet">
                <div class="order-summary-block">
                  
                  <!-- Shipping detail -->
                  <div class="content-box pt15 px0" v-if="enabledLoyality">
                    <div class="cart-sidebar-promocode loyality-point-wrapper">
                      <h3  class="is-size-16 has-text-weight-bold font-color mb15">
                        {{ vg_businessLoyality.name ? vg_businessLoyality.name : ''}} 
                        <span class="is-size-12 has-text-weight-bold loyality-points-display opacity-6" v-if="vg_cartLoyalityPointsObj.points_redeemable">
                          {{ (vg_cartLoyalityPointsObj.points_redeemable > vg_userLoyalitySubscriptionObj.points) ? new Intl.NumberFormat().format(vg_userLoyalitySubscriptionObj.points) : new Intl.NumberFormat().format(vg_cartLoyalityPointsObj.points_redeemable) }} points
                        </span>
                      </h3>
                      <template v-if="vg_loggedInUser && vg_loggedInUser.email_verification_status">
                        <div class="cart-sidebar-promocode-content" v-if="vg_cartLoyalityPointsObj.points_redeemable"> 
                          <input class="promocode-input font-color hide-default-numb-style" v-model="loyality_point" value="" type="number" placeholder="Input Points"/>
                          <button @click.prevent="applyLoyalityPoint()" :class="'cart-modal-apply-promocode has-text-weight-semibold' + (loyality_point ? '' : ' field-disabled opacity-03') ">APPLY</button>
                        </div>
                        <p class="is-size-12 mt-5 has-text-weight-semibold" v-else>Your cart doesn’t have any items you can use points for.</p>
                      </template>
                      <template v-else>
                        <p class="is-size-14">Your account needs to be verified to redeem points.</p>
                      </template>
                    </div>
                  </div>

                  <div class="content-box pt15 px0">
                    <div class="cart-sidebar-promocode loyality-point-wrapper">
                      <h3  class="is-size-16 has-text-weight-bold font-color mb15">Promo Code</h3>
                      <div class="cart-sidebar-promocode-content"> 
                         <input class="promocode-input font-color" v-model="promocode" value="" placeholder="Input Promo Code"/>
                        <button @click.prevent="applyPromoCode()" :class="'cart-modal-apply-promocode has-text-weight-semibold' + (promocode ? '' : ' field-disabled opacity-03') ">APPLY</button>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="content-box pt15">
                    <div class="cart-promocode-wrapper">
                      <div class="promocode-field">
                        <span class="promocode-label bg-secondary-full font-color">Promo Code</span>
                        <input class="promocode-input font-color" v-model="promocode" value="" placeholder="Your promocode"/>
                        <button @click.prevent="applyPromoCode()" class="promocode-apply-sm font-color is-hidden-tablet">APPLY</button>
                      </div>
                      <button @click.prevent="applyPromoCode()" class="button is-hidden-mobile mt-5 is-primary-outline cart-add-more is-medium is-full-width">
                        APPLY
                      </button>
                    </div>
                  </div> -->

                  <div class="cart-review-order all-text-dark-important">
                    <div class="content-box tax-price">
                      <h3
                        class="title has-text-dark is-size-16 has-text-weight-bold">
                        Review Order
                      </h3>
                      <table class="cart-table">
                        <tr v-bind:key="'cart-item_' + index" v-for="(product, index) in vg_cartItems">
                          <td class="td-product-name has-text-dark is-size-14">{{ product.product_name }}</td>
                          <td
                            class="td-product-info has-text-dark text-right is-size-14"
                          >{{ product.selected_variant.weight_equivalent_dry_cannabis }}{{ product.weighing_unit ? product.weighing_unit : '' }} X {{ product.unit }}</td>
                          <td
                            class="td-product-price text-right has-text-dark is-size-14"
                          >
                            <span v-if="hasSalePrice(product)" class="opacity-8 has-text-dark"><s class="opacity-03">${{ (product.unit * product.selected_variant.price).toFixed(2)}}</s><br/></span>
                            ${{ (product.unit * product.price).toFixed(2) }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="sub-total-line dark"></div>
                    <div class="content-box subtotal-box">

                      <div class="level is-mobile mb5" v-if="vg_is_greenline_pos">
                        <div class="level-left">
                          <div class="level-item">
                            <p class="sf-pro-text-regular is-size-14 has-text-dark">Deposit</p>
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="level-item">
                            <p class="sf-pro-text-regular has-text-dark is-size-14">
                              <span class="has-text-dark">${{ vg_greenlineProductDeposit }}</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="level is-mobile mb10" v-if="!vg_is_greenline_pos">
                        <div class="level-left">
                          <div class="level-item">
                            <p class="sf-pro-text-regular is-size-14 has-text-dark">Subtotal</p>
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="level-item">
                            <p class="sf-pro-text-regular has-text-dark is-size-14">
                              <!-- <span class="subtotal-without-sale-price has-text-dark strike" v-if="activeSalePriceData.hasActiveSale"><s class="opacity-03">${{ activeSalePriceData.regularPrice}}</s></span>${{ vg_cartSubTotal }} -->
                               <span :class="'has-text-dark' + ( (vg_cartPromoCode) ? ' strike dark' : '')">${{ vg_cartSubTotal }}</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="level is-mobile mb10" v-if="vg_cartPromoCode">
                        <div class="level-left">
                          <div class="level-item">
                            <p class="sf-pro-text-regular is-size-14 has-text-dark"><span class="removed-promocode" @click.prevent="removePromoCode()"><i class="fa fa-times-circle" aria-hidden="true"></i></span> Promo Code ({{ vg_cartPromoCode.code}})</p>
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="level-item">
                            <p class="text-green is-size-14">
                              - ${{ vg_cartPromoCode.applied_value.toFixed(2) }} 
                            </p>
                          </div>
                        </div>
                      </div>


                      <div class="level is-mobile mb5" v-if="vg_cartPromoCode && !vg_is_greenline_pos">
                        <div class="level-left">
                          <div class="level-item">
                            <p class="has-text-dark sf-pro-text-regular is-size-14">New Subtotal</p>
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="level-item">
                            <p class="sf-pro-text-regular text-green is-size-14">${{ vg_newSubTotal }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="level is-mobile mb5">
                        <div class="level-left">
                          <div class="level-item">
                            <p class="sf-pro-text-regular is-size-14 has-text-dark">Tax</p>
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="level-item">
                            <p class="sf-pro-text-regular is-size-14 has-text-dark">${{ vg_cartTax ? vg_cartTax : 0.00 }}</p>
                          </div>
                        </div>
                      </div>

                      <div class="level is-mobile mb5" v-if="vg_cartLoyality">
                        <div class="level-left">
                          <div class="level-item">
                            <p class="sf-pro-text-regular is-size-14 has-text-dark"><span class="removed-promocode" @click.prevent="removeLoyality()"><i class="fa fa-times-circle" aria-hidden="true"></i></span>  Points Used: {{ vg_cartLoyality.points_to_redeem }}</p>
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="level-item">
                            <p class="sf-pro-text-regular has-text-dark is-size-14">
                              - ${{ vg_cartLoyality.redeem_amount.toFixed(2) }} 
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="content-box subtotal-box no-border-bottom">
                      <div class="level is-mobile">
                        <div class="level-left">
                          <div class="level-item">
                            <p class="is-size-16 has-text-weight-bold has-text-dark">Total</p>
                          </div>
                        </div>
                        <div class="level-right">
                          <div class="level-item">
                            <p class="is-size-16 has-text-weight-bold has-text-dark">${{ cartGrandTotal.toFixed(2) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- if pickup direct show btn -->
                  <a
                    @click.prevent="moveToCheckout()"
                    href="#"
                    class="button pa15 height-auto has-text-weight-bold bg-secondary text-white hover-opacity-7 is-full-width"
                  >
                  CHECKOUT
                  </a>

          
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>
   
      <remove-item-modal></remove-item-modal>
      <user-not-logged-in-modal></user-not-logged-in-modal>
      <cart-clear></cart-clear>
      <no-longer-stock></no-longer-stock> 
      <!-- <mobile-footer-actions/>-->
    </div>
  </div>
</template>

<script>

import CartItem from '@/Components/Pages/PageComponents/Cart/Item';
import CartSkeleton from '@/Components/Pages/PageComponents/Cart/Skeleton';


import ConfirmOrderModal from '@/Components/Pages/PageComponents/Cart/ConfirmOrderModal';
import RemoveItemModal from '@/Components/Pages/PageComponents/Cart/RemoveItemModal';
import UserNotLoggedInModal from '@/Components/Pages/PageComponents/Cart/UserNotLoggedInModal';
import CartClear from '@/Components/Pages/PageComponents/Cart/ClearCart';
import NoLongerStock from '@/Components/Pages/PageComponents/Cart/NoLongerStock';

// lets make a individual component instead, to less methods on this file
import MobileFooterActions from '@/Components/Pages/PageComponents/Cart/MobileFooterActions';
import CartApis from '@/Components/Controllers/CartApis';
import LocationApis from '@/Components/Controllers/LocationApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis'
import UserApis from '@/Components/Controllers/UserApis';
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import { find, indexOf } from 'lodash';
import moment from 'moment';

export default {
  components: {
    ConfirmOrderModal,
    CartItem,
    RemoveItemModal,
    UserNotLoggedInModal,
    CartClear,
    NoLongerStock,
    MobileFooterActions,
    CartSkeleton,
  },
  name: 'Cart',
  data() {
    return {
      cartLoaded: true,
      loaded: false,
      promocode: '',
      loyality_point: '',
    };
  },
  computed: {
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_cartLoyality: "cart/loyality",
      vg_businessProfile: "businessprofile/detail",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_cartPromoCode: "cart/promocode",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_userId: "getLoggedInUserId",
      vg_cartLoyalityPointsObj: "cart/loyalityPointsObj",
      vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
      vg_hasBusinessLoyalityProgram: "businessprofile/hasBusinessLoyalityProgram",
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
      vg_loggedInUser: "getLoggedInUser",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_is_tendy_pos: "location/is_tendy_pos",
      vg_greenlineProductDeposit: "cart/greenline_product_deposit",
      vg_newSubTotal: "cart/newSubTotal",
    }),

    enabledLoyality() {
      // user must be logged in  // user must have subscribed to the programme // business must have enable program
      if(this.vg_userId && this.vg_userLoyalitySubscription && this.vg_hasBusinessLoyalityProgram){
        this.step = 'ordertype';
        return true;
      }
      return false;
    },

    activeSalePriceData() {
      let hasActiveSale = false;
      let regularPrice = 0;
      
      this.vg_cartItems.map(item => {
        if(parseFloat(item.selected_variant.sale_price) > 0 && parseFloat(item.selected_variant.sale_price) < parseFloat(item.selected_variant.price)){
          hasActiveSale = true;
        } 
        regularPrice += item.unit * item.selected_variant.price;
      })
      return {
        hasActiveSale,
        regularPrice: regularPrice.toFixed(2)
      };
    },


    /**
     * Guest user / guest_only active
     */
    guestOnly() {
      if ( this.$route.query['guest-only'] || this.vg_guestLandedQueries['guest-only'] || (this.vg_guestLandedQueries['guest-only'] == 'true') ) {
        return this.vg_selectedStore.settings.kiosk_settings ? this.vg_selectedStore.settings.kiosk_settings.is_enabled : false
      }
      return false;
    },

    cartGrandTotal() {
      if(this.vg_is_greenline_pos){
         return parseFloat(this.vg_cartGrandTotal)
      } else {
        return parseFloat(this.vg_cartGrandTotal);
      }
     
    },

  },

  watch: {
    vg_cartItems: {
      deep: true,
      handler(){
        // When cart is update remount the cart item component to assign uit to custom qty
        this.cartLoaded = false;
        this.$nextTick(() => {
          this.cartLoaded = true;
          this.onCartItemChange();
        })
      }
    },


    'delivery.phone'(val, oldVal) {
      if (val && val.length > 10) {
        this.delivery.phone = oldVal;
      }
    },
  },

  async created() {
   
  },

  async mounted() {
    this.loaded = false;
    const self = this;
    // Incase user directly lands on this page via url, setting business and location
    // let businessRes = await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);
    // let locationRes = await LocationApis.fetchBySlug(this.$route.params.store_slug);
    // if(locationRes.status == 200){
    //   self.va_setSelectedLocation(locationRes.data.payload);
    // }
    if(!this.vg_selectedStore.id){
      this.va_snackbar({
        type: "warning",
        message: "Cannot find the store."
      });
       return this.$router.push({ 
        name: 'HomePage', 
        params: {
          business_slug: this.$route.business_slug
        },
        query: this.$route.query,
      });
    }

    await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
    this.loaded = true;
    bus.$on('listen-mobile-moveto-checkout', () => {
      // listen from mobile screen
      this.moveToCheckout();
    })
    // this.va_setCartLoyalityPointsObj();

    if(self.vg_userId && self.vg_businessLoyality.id && self.vg_businessLoyality.is_active){

      await self.va_setUserLoyalityObj({
        user_id: self.vg_userId, 
        business_id: self.vg_businessProfile.id,
      });

      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, this.vg_selectedStore.id, this.$route.query);
        setTimeout(()=> {
          Helpers.pubnubSubscribeAllChannels({ 
            user_id: this.$store.getters.getLoggedInUserId, 
            location_id: this.vg_selectedStore.id
          });
          Helpers.emitUserActivity();
        }, 1000)
      }

    }

    if(this.vg_is_greenline_pos){
      this.fetchGreenLinePosData();
    } else if(this.vg_is_tendy_pos) {
      this.fetchTendyPosData()
    }

    

  },
  
  beforeDestroy() {
    bus.$off('listen-mobile-moveto-checkout');
  },

  methods: {
    /**
     * Move backwards
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Act on on change cart item 
     */
    onCartItemChange: _.debounce(function() {
      // Prevent multiple hits
      if(this.vg_is_greenline_pos){
        // If any change on cart item fetch pos if greenline pos
        this.fetchGreenLinePosData();
      } else if(this.vg_is_tendy_pos) {

        this.fetchTendyPosData();
      }
      // When cart is update remount the cart item component to assign uit to custom qty
      this.cartLoaded = false;
      this.$nextTick(() => {
        this.cartLoaded = true;
        // if cart item change get loyality points
        // Fetch only if user is not logged in because if logged in we are watching on pubnub 
        if(this.vg_cartItems.length > 0) {
          this.va_setCartLoyalityPointsObj({
            order_receive_method: 'pickup'
          });
        } else {
          this.vm_cartLoyaltyPointMutate({})
        }
      })
    }, 1000),

    /**
     * Move to checkout
     */
    async moveToCheckout() {
      this.$router.push({
        name: 'Checkout',
        params: {
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug
        },
        query: this.$route.query,
      })
    },

    /**
    * Clear cart modal
    */
    clearCartModal() {
      if (this.vg_cartId) {
        bus.$emit('show-modal-clear-cart', true);
      } else {
        this.va_snackbar({
          type: "warning",
          message: "Cannot find cart."
        });
      }
    },

    hasSalePrice(item) {
      if(parseFloat(item.selected_variant.sale_price) > 0 && parseFloat(item.selected_variant.sale_price) < parseFloat(item.selected_variant.price)){
        return true;
      }
      return false;
    },

    /**
     * Attach promocode on cart
     */
    async applyPromoCode() {
      if(this.promocode == ''){
        return this.va_snackbar({
          type: "warning",
          message: `Please enter promocode.`,
        });
      }
      this.va_spinner(true);
      let res = await CartApis.promoCodeApply({
        cart_id: this.vg_cartId, 
        promocode: this.promocode, 
        business_id: this.vg_businessProfile.id,
        user_type: (this.vg_userId && (this.vg_loggedInUser.status == 'registered') ) ? 'registered' : 'guest',
      });
      // on success fetch cart
      if(res.status == 200){
        await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this))
      } 
      this.promocode = '';
      this.va_spinner(false);
      this.va_snackbar({
        type: res.status == 200 ? "success" : "warning",
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
    },

    /**
     * Remove promocode
     */
    async removePromoCode() {
      if(this.vg_cartPromoCode.code == ''){
        return this.va_snackbar({
          type: "warning",
          message: `Sorry promocode not found.`,
        });
      }
      this.va_spinner(true);
      let res = await CartApis.promoCodeRemove(this.vg_cartPromoCode.id);
      // on success fetch cart
      if(res.status == 200){
        this.promocode = '';
        await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this))
      } else {
        // If success pubnub will return message, so lets handle error part only
        this.va_snackbar({
          type:  "warning",
          message: res.response.data.msg,
        });
      }
      // refetch cart
      this.va_spinner(false);
    },

    /**
     * Apply loyality
     */
    async applyLoyalityPoint() {
      this.va_spinner(true);
      let res = await CartApis.redeemPointOnCart({
        cart_id: this.vg_cartId,
        points_to_redeem: parseInt(this.loyality_point),
        order_received_method: this.$store.getters['getInStore'] ? 'instore' : 'pickup',
      })
      
      if(res.status == 200){
        this.loyality_point = '';
        this.$store.dispatch('cart/setCartDetail', res.data.payload);
        this.$store.dispatch('cart/setCartItems', res.data.payload.cart_items);
      }
      this.va_spinner(false);
      return this.va_snackbar({
        type: res.status == 200 ? "success" : "warning",
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
    },

    /**
     * Remove loyality point
     */
    async removeLoyality() {
      this.va_spinner(true);
      let res = await CartApis.removeRedeemPointOnCart(this.vg_cartLoyality.id);
       if(res.status == 200){
        this.$store.dispatch('cart/setCartDetail', res.data.payload);
        this.$store.dispatch('cart/setCartItems', res.data.payload.cart_items);
      }
      this.va_spinner(false);
    },

    /**
     * Fetch green pos
     */
    async fetchGreenLinePosData() {
      let posdat = {};
      posdat.order_receive_method = "pickup"; // at this stage because its sidebar cart on selected yet
      if(this.vg_userId){
        posdat.user = {
          first_name: this.vg_loggedInUser.first_name,
          last_name: this.vg_loggedInUser.last_name
        }
      }
      this.va_setGreenLinePosData(posdat);
    },

    /**
     * Fetch Tendy pos
     */
    async fetchTendyPosData() {
      let posdat = {
        order_receive_method: 'pickup',
        in_store: this.$store.getters['getInStore'] ? true : false,
      };
    
      if(this.vg_userId){
        posdat.user = {
          first_name: this.vg_loggedInUser.first_name,
          last_name: this.vg_loggedInUser.last_name
        }
      }
      this.va_setTendyPosData(posdat);
    },

    ...mapMutations({
      vm_cartLoyaltyPointMutate: "cart/loyalityPointsObjMutate",
    }),

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setCartLoyalityPointsObj: "cart/setLoyalityPointsObj",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_setGreenLinePosData: "cart/setGreenLinePosData",
      va_setTendyPosData: "cart/setTendyPosData",
      va_setPastSelectedLocationId: "location/setPastSelectedLocationId",
    })

  },
};
</script>
<style scoped>
.text-sm {
  font-size: 13px;
}
.nab-bar-left {
  display: flex;
  flex-direction: row;
}
.nav-bar-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: 100%; */
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.nav-bar-right {
  padding-right: 30px;
}
h1.title {
  margin-top: 9px;
}
.width-300 {
  max-width: 300px;
}
.width-100 {
  width: 100px;
}
.cart-wrapper .order-summary-block .content-box {
  padding: 5px 15px;
}
.cart-wrapper .order-summary-block .content-box.px0 {
  padding: 5px 0px;
}
img.clock {
  left: 15px !important;
}
.ml-10 {
  margin-left: 10px;
}

.nav-bar-wrapper{
  height: 100%;
}
.nab-bar-left{
  align-items: center;
}
</style>
